import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Toolbar,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import styles from './BackofficeTestDialog.module.scss';
import { useEffect, useState } from 'react';

export interface BackofficeTestDialogProps {
    open: boolean;
    status: 'fail' | 'success' | null;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const BackofficeTestDialog = ({
    open,
    status,
    setOpen,
}: BackofficeTestDialogProps) => {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (status) {
            if (status === 'fail') {
                setTitle('Failure');
                setMessage('Check your connection information');
            } else if (status === 'success') {
                setTitle('Success!');
                setMessage('You are all set!');
            }
        }
    }, [status, open]);
    return (
        <div>
            <Dialog
                data-testid="BackofficeTestDialog"
                open={open}
                maxWidth="sm"
                fullWidth
                onClose={() => setOpen(false)}
            >
                <Toolbar>
                    <Typography className={styles.modalHeader} variant="h6">
                        {title}
                    </Typography>
                    <IconButton
                        color="inherit"
                        onClick={() => {
                            setOpen(false);
                        }}
                        aria-label="close"
                    >
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent>{message}</DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        Got it!
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
